import axios from './axiosInstance';

export const addBlog = async ({
  title,
  summary,
  details
}) => {
  try{
    const response = await axios({
      url : '/add-blog',
      method : 'POST',
      data : {
        title : title,
        summary : summary,
        details : details
      }
    })

    return({
      data : response.data,
      error : null
    })

  }catch(error){
    return{
      data : null,
      error : error
    }
  }
}

export const listBlogs = async ({
  page,
  limit,
  search
}) => {

  let params = {};

  if(page !== null){
    params.page = page
  }
  if(limit){
    params.limit = limit
  }
  if(search){
    params.search = search
  }
  try{
    const response = await axios({
      url : '/list-blogs',
      method : 'GET',
      params : params
    })

    return({
      data : response.data,
      error : null
    })

  }catch(error){
    return{
      data : null,
      error : error
    }
  }
}

export const updateBlog = async ({
  data,
  id
}) => {

  try{
    const response = await axios({
      url : `/update-blog/${id}`,
      method : 'PUT',
      data : data
    })

    return({
      data : response.data,
      error : null
    })

  }catch(error){
    return{
      data : null,
      error : error
    }
  }
}

export const getBlog = async ({
  id
}) => {

  try{
    const response = await axios({
      url : `/get-blog/${id}`,
      method : 'GET'
    })

    return({
      data : response.data,
      error : null
    })

  }catch(error){
    return{
      data : null,
      error : error
    }
  }
}